/* BOELLE 2-pack: products on the "2-pack" template are sold in pairs (2, 4, 6, 8, 10).
   Extends the theme's <quantity-input> so a typed value snaps to a valid multiple of the input's step.
   Only inputs with step > 1 are affected; normal products (step 1) are untouched. */
(function () {
  var QuantityInput = customElements.get('quantity-input');
  if (!QuantityInput) return;
  var proto = QuantityInput.prototype;
  var originalOnInputChange = proto.onInputChange;

  proto.snapToStep = function () {
    var input = this.input;
    if (!input) return;
    var step = parseInt(input.step) || 1;
    if (step <= 1) return;
    var value = parseInt(input.value) || 0;
    var min = parseInt(input.min) || 0;
    var max = input.max ? parseInt(input.max) : null;
    if (value % step !== 0) value = Math.round(value / step) * step;
    if (value < min) value = min;
    if (value === 0 && min > 0) value = step;
    if (max !== null && value > max) value = max;
    if (String(value) !== input.value) input.value = value;
  };

  proto.onInputChange = function () {
    if (this.input && this.input.value === '') {
      this.input.value = parseInt(this.input.min);
    }
    this.snapToStep();
    return originalOnInputChange.apply(this, arguments);
  };
})();
